export const isInvalidPassword = (str: string) => {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}$/;

  return !regex.test(str);
};
